<template>
  <div>
    <v-app-bar
        absolute
        app
        color="transparent"
        flat
        height="75"
    >

        <v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon>
        
        <template v-if="isSensorPath">
            <v-toolbar-title style="color: black; margin-right: 15px;"> Dispositivo {{deviceName}}</v-toolbar-title>
            {{date | dateFormat}}
            <v-spacer></v-spacer>
            <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                    >
                        Seleccionar fecha
                    </v-btn>
                </template>
                <v-date-picker
                    v-model="date"
                    locale="es-us"
                    :first-day-of-week="1"
                    :max="lastDayReport"
                    :range="isRangeDate"
                >
                    <v-row class="text-center" style="margin-top: -20px;">
                        <v-col cols="12" sm="12">
                            <v-btn-toggle
                                v-model="dayReportSingle"
                                mandatory
                            >
                                <v-btn small>
                                    Diario
                                </v-btn>
                                <v-btn small>
                                    Rango
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    
                        <v-col cols="12" sm="12">
                            <v-btn
                                color="primary"
                                @click="$refs.dialog.save(date); getInfoDate()"
                            >
                                Ver Datos
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-date-picker>
            </v-dialog>
        </template>
        <template v-else-if="isSensorCompare">
            <v-toolbar-title style="color: black;"> {{titlePage}} </v-toolbar-title>
            {{date | dateFormat}}
            <v-spacer></v-spacer>
            <v-dialog
                ref="dialogCompare"
                v-model="dialogCompare"
                :return-value.sync="date"
                width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                    >
                        Seleccionar fecha
                    </v-btn>
                </template>
                <v-date-picker
                    v-model="date"
                    locale="es-us"
                    :first-day-of-week="1"
                    :max="today"
                    scrollable
                >
                    <v-row class="text-center">
                        <v-col cols="12" sm="12">
                            <v-btn
                                color="primary"
                                @click="$refs.dialogCompare.save(date);setDay()"
                            >
                                Seleccionar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-date-picker>
            </v-dialog>
       
        </template>
        <template v-else-if="isProjectTest">
            <v-toolbar-title style="color: black;"> {{titlePage}} </v-toolbar-title>
            {{date | dateFormat}}
            <v-spacer></v-spacer>
            <v-dialog
                ref="dialogContinumm"
                v-model="dialogContinumm"
                :return-value.sync="date"
                width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                    >
                        Seleccionar fecha
                    </v-btn>
                </template>
                <v-date-picker
                    v-model="date"
                    :allowed-dates="allowedDates"
                    locale="es-us"
                    :first-day-of-week="1"
                >
                    <v-row class="text-center">
                        <v-col cols="12" sm="12">
                            <v-btn
                                color="primary"
                                @click="$refs.dialogContinumm.save(date)"
                            >
                                Seleccionar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-date-picker>
            </v-dialog>
       
        </template>
        <template v-else-if="isSensorResume">
            <v-toolbar-title style="color: black;"> {{titlePage}} </v-toolbar-title>
            {{ rangeMonth | dateFormatMothn }}
            <v-spacer></v-spacer>
            <v-dialog
                ref="dialogResume"
                v-model="dialogResume"
                :return-value.sync="date"
                width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                    >
                        Seleccionar fecha
                    </v-btn>
                </template>
                <v-date-picker
                    v-model="dateMonth"
                    type="month"
                    locale="es-en"
                    range
                    no-title
                    scrollable
                >
                    <v-row class="text-center">
                        <v-col cols="12" sm="12">
                            <v-btn
                                color="primary"
                                @click="$refs.dialogResume.save(dateMonth)"
                            >
                                Selecionar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-date-picker>
            </v-dialog>
       
        </template>
        <template v-else>
            <v-toolbar-title style="color: black;"> {{titlePage}} </v-toolbar-title>
            <v-spacer></v-spacer>
        </template>
        <!-- <v-btn icon to="/deviceConfig">
            <v-icon>mdi-cogs</v-icon>
        </v-btn> -->
        <v-btn
            v-if="isMaintainer"
            icon
            @click="dialogProject = true"
        >
            <v-icon>mdi-clipboard-flow</v-icon>
        </v-btn>
        <v-menu
            transition="slide-y-transition"
            bottom
            z-index="25"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>mdi-cogs</v-icon>
                </v-btn>
            </template>
            <v-list nav dense>
                <v-list>
                    <v-list-item
                        v-for="(item, i) in permittedItems"
                        :key="i"
                        link
                        :to="item.link"
                    >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-list-item link>
                    <v-list-item-title @click="logout"> Desconectar </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
    <v-dialog
        v-model="dialogProject"
        width="380px"
    >
        <v-card>
            <v-card-title>
                <span class="headline">Redes Continuas disponibles</span>
            </v-card-title>
            <v-card-text>
                <v-list>
                    <v-list-item-group
                        v-model="selectProject"
                        color="primary"
                    >
                        <v-list-item
                            >
                            <v-list-item-content>
                                <v-list-item-title> TODOS </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-for="project in projects"
                            :key="project.name"
                        >
                            <v-list-item-content>
                                <v-list-item-title> {{ project.name }}</v-list-item-title>
                            </v-list-item-content>   
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="dialogProject = false"
                >
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
  
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'BarApp',

		data: () => ({
            selectProject: null,
            items: [
                { title: 'Perfil', icon: 'mdi-home-analytics', link: '/', rol:'user'},
                { title: 'Redes Continuas', icon: 'mdi-home-analytics', link: '/projects', rol:'admin'},
                { title: 'Usuarios', icon: 'mdi-home-analytics', link: '/users', rol:'dev'},
                { title: 'Dispositivos', icon: 'mdi-home-analytics', link: '/deviceConfig', rol:'dev'},
                { title: 'Etiquetas', icon: 'mdi-home-analytics', link: '/annotation', rol:'admin'},
                { title: 'Import Device', icon: 'mdi-home-analytics', link: '/import', rol:'dev'},
            ],
            date: moment().format("YYYY-MM-DD"),
            dateMonth: [moment().format("YYYY-MM")],
            menu: false,
            modal: false,
            dialogResume: false,
            dialogCompare: false,
            dialogContinumm: false,
            dialogProject: false,
            menu2: false,
            compareInterval: null,
            reportsInterval: null,
            dayReportSingle: 0
		}),

        computed: {
            drawer () {
                return this.$store.getters.drawer
            },

            user () {
                return this.$store.getters.user
            },
            devices () {
                return this.$store.getters.devices
            },
            titlePage () {
                return this.$route.name
            },
            path () {
                return this.$route.path
            },
            isLaeqPath () {
                return this.$route.path.indexOf('/laeq') > -1
            },
            isSensorPath () {
                return this.$route.path.indexOf('/sensor') > -1 || this.$route.path.indexOf('/laeq') > -1
            },
            isSensorCompare () {
                return this.$route.path.indexOf('/compare') > -1
            },

            isProjectTest () {
                return this.$route.path.indexOf('/projects/view') > -1
            },
            
            isSensorResume () {
                return this.$route.path.indexOf('/resume') > -1
            },
            rangeMonth () {
                if (this.dateMonth.length == 1)
                    return { from: this.dateMonth[0] }

                if (this.dateMonth.length == 2) {
                    const compareDates = (date1, date2) => {
                        if (date1 < date2)
                            return -1
                        else if (date1 > date2)
                            return 1
                        else
                            return 0
                    }

                    this.dateMonth.sort(compareDates);

                    return { from: this.dateMonth[0], to: this.dateMonth[1] }
                }

                return null
            },
            deviceName () {
                const findDevice = this.$store.getters.device(this.$route.params.id)
				return findDevice !== undefined ? findDevice.name : ''
            },
            devicesInfo() {
                return this.$store.getters.devicesInfo
            },
            deviceId () {
                return this.$route.params.id
            },
            permittedItems () {
                return this.items.filter ( e => {
                    return this.user.roles.some ( u => {
                        return u.name === e.rol
                    })
                })
            },
            isAdmin () {
                return this.user.roles.some ( e => {
                    return e.name === "admin"
                })
            },
            isMaintainer () {
                return this.user.roles.some ( e => {
                    return e.name === "maintainer"
                })
            },
            projects () {
                return this.$store.getters.projects
            },

            viewProjectTest () {
                return this.$store.getters.viewProjectTest
            },

            viewProjectTestName () {
                return this.viewProjectTest.name
            },

            viewProjectAvailableData () {
                return this.viewProjectTest.availableData ? this.viewProjectTest.availableData : []
            },
            
            lastDayReport () {
                return moment(this.devicesInfo[this.deviceId]).format("YYYY-MM-DD")
            },

            isRangeDate () {
                return this.dayReportSingle == 1
            },

            today () {
                return moment().format("YYYY-MM-DD")
            }
        },
        
        methods : {
            toggleDrawer () {
                this.$store.dispatch('toggleDrawer', !this.drawer)
            },

            logout () {
                this.$store.dispatch('logout')
                this.$router.push('/login')
            },

            allowedDates (val) {
                return this.viewProjectAvailableData.includes(val)
            },

            getInfoDate () {
                this.modal = false
                let date = this.date
                let endDate

                if (Array.isArray(date)) {
                    const range = this.sortRange(date)
                    date = range.from
                    endDate = range.to
                }

                let payload = {
                    deviceId: this.$route.params.id,
                    date: date,
                    endDate: endDate
                }


                if (this.isLaeqPath)
                    payload.sensor = "laeq_001"

                this.setDay()

                const isToday = moment().isSame(date, 'days')

                if (this.isSensorCompare)
                    return

                this.$store.dispatch('handleLoading', true)
                clearInterval(this.compareInterval)
                clearInterval(this.reportsInterval)

                this.$store.dispatch('pullDeviceDateReport', { ...payload, loading: true })
                this.$store.dispatch('pullWindRoseData', payload)
                this.$store.dispatch('pullClassificationEvents', payload)

                if (isToday) {
                    this.reportsInterval = setInterval(() => {
                        this.$store.dispatch('pullDeviceDateReport', { ...payload, loading: false })
                        this.$store.dispatch('pullWindRoseData', payload)
                        this.$store.dispatch('pullClassificationEvents', payload)
                    }, 60 * 1000);
                }
            },

            sortRange (date) {
                if (date.length == 1)
                    return { from: date[0] }

                if (date.length == 2) {
                    const compareDates = (date1, date2) => {
                        if (date1 < date2)
                            return -1
                        else if (date1 > date2)
                            return 1
                        else
                            return 0
                    }

                    date.sort(compareDates)

                    return { from: date[0], to: date[1] }
                }

                return null
            },

            setDay() {
                this.$store.dispatch('viewDate', this.date)
            }
        },

        filters : {
			dateFormat (val) {
                if ( Array.isArray(val) ) {
                    if (!moment(val[0]).isValid())
                        return val

                    if (!moment(val[1]).isValid())
                        return val

                    return `Desde ${moment(val[0]).format('LL')} a ${moment(val[1]).format('LL')}`
                } else {
                    if (!moment(val).isValid())
                        return val
    
                    return moment(val).format('LL')
                }
			},
			dateFormatMothn (val) {
                let date = `Desde ${moment(val.from).format('MMMM YYYY')}`

                if (val.hasOwnProperty('to'))
                    date += ` a ${moment(val.to).format('MMMM YYYY')}`

				return date
			},
        },
        
        watch: {
            rangeMonth (val) {
                this.$store.dispatch('viewRangeDate', val)
            },
            
            deviceId (val) {
                this.date = this.lastDayReport

                let payload = {
                    deviceId: val,
                    date: this.date
                }

                if (this.isLaeqPath)
                    payload.sensor = "laeq_001"

                clearInterval(this.reportsInterval)
                this.$store.dispatch('pullDeviceDateReport', {...payload, loading: true })
                this.$store.dispatch('pullWindRoseData', payload)
                this.$store.dispatch('pullClassificationEvents', payload)

		        this.reportsInterval = setInterval( () => {
                    this.$store.dispatch('pullDeviceDateReport', { ...payload, loading: false })
                    this.$store.dispatch('pullWindRoseData', payload)
                    this.$store.dispatch('pullClassificationEvents', payload)
                }, 60 * 1000);
            },

            selectProject (val) {
                if (val === undefined)
                    this.selectProject = 0

                const project = this.selectProject === 0 ? 'all' : this.projects[this.selectProject - 1].projectId
                const payload = {
                    project: project
                }

                this.$store.dispatch('setProject', payload)
                this.$store.dispatch('pullDevices')
                this.$store.dispatch('pullSensors')
                this.$store.dispatch('pullAllSensors')
                this.$store.dispatch('pullInfoDevices')
                this.dialogProject = false
            },

            viewProjectAvailableData (val) {
                if (val.length > 0 )
                    this.date = val[val.length - 1]
            },

            isSensorPath (val) {
                if (val)
                    this.dayReportSingle = 0
            },

            dayReportSingle (val) {
                if (this.dayReportSingle == 0)
                    this.date = this.date[0]
            }
        },

        created () {
            if (this.devices.length === 0)
                this.$store.dispatch('pullDevices')

            this.$store.dispatch('pullProjects')
            this.$store.dispatch('viewRangeDate', this.rangeMonth)
        }
	}
</script>